import { __awaiter, __generator } from "tslib";
export var IV_LENGTH = 12;
export function generateInitializationVector() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, window.crypto.getRandomValues(new Uint8Array(IV_LENGTH))];
        });
    });
}
export function getIvAndEncryptedBuffer(encryptedBufferWithIv) {
    // The first IV_LENGTH bytes are the IV
    var iv = encryptedBufferWithIv.slice(0, IV_LENGTH);
    // The remaining bytes are the encrypted buffer.
    var encryptedBuffer = encryptedBufferWithIv.slice(IV_LENGTH, encryptedBufferWithIv.byteLength);
    return [iv, encryptedBuffer];
}
//# sourceMappingURL=InitializationVector.js.map